import * as request from '../../request'
import * as serializers from './serializers'

export const getKnowledgeBases = async ({ params } = {}) => {
  try {
    const res = await request.get('v1/knowledge-bases', { params })

    return serializers.getKnowledgeBasesSerialize(res.response.data)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getById = async (id) => {
  try {
    const res = await request.get(`v1/knowledge-bases/${id}`)

    return serializers.itemSerialize(res.data)
  } catch (err) {
    return Promise.reject(err)
  }
}

export const toggleFavorite = async (item) => {
  try {
    let res
    if (item.isFavorite) {
      res = await request.del(`v1/knowledge-bases/${item.id}/favorite`)
    } else {
      res = await request.post(`v1/knowledge-bases/${item.id}/favorite`)
    }

    return res
  } catch (err) {
    return Promise.reject(err)
  }
}

export const getCategories = async () => {
  try {
    const res = await request.get(`v1/knowledge-bases/categories`)

    return serializers.getCategoriesSerialize(res)
  } catch (err) {
    return Promise.reject(err)
  }
}
